import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import { useHotkeys } from 'react-hotkeys-hook'
import hotkeys from 'src/lib/hotkeys'

import SchoolForm from 'src/components/SchoolCell/SchoolForm'
const SchoolEditModal = ({ isOpen, onClose, trigger, school }) => {
  const scrollBehavior = 'outside'

  useHotkeys(
    hotkeys.escape,
    (e) => {
      e.preventDefault()
      onClose()
    },
    {
      enabled: isOpen,
    }
  )
  return (
    <>
      {trigger}
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        size="xl"
        scrollBehavior={scrollBehavior}
      >
        <ModalOverlay />
        <ModalContent maxWidth="45rem">
          <ModalHeader>Edit School</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SchoolForm school={school} onSave={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

export default SchoolEditModal
